// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__VFnI9","content":"ManualTimeModal_content__RaqjT"};